import React from "react";
import { Row, Col, message, Button, Space, Tooltip, Modal } from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import { Link } from "react-router-dom";

import { PlusOutlined, DeleteFilled, FileOutlined } from "@ant-design/icons";
import DeleteConfirm from "./DeleteConfirm";
import ListTable from "./ListTable";

import CompanyAutocomplete from "./CompanyAutocomplete";

import config from "../config";
import VehicleGroupStore from "../store/VehicleGroupStore";
import withRouter from "../withRouter";
import VehicleGroupAdd from "./VehicleGroupAdd";
import CompanyStore from "../store/CompanyStore";

class VehicleGroupList extends React.Component {
  constructor(props) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.vehicleGroupStore = new VehicleGroupStore();
    this.companyStore = new CompanyStore(this);

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      openConfirm: false,
      confirmLoading: false,
      companyId: "",
      loadData: 0,
      listDataUpdate: false,
      openGroupAddFom: false,
      vehicleGroupId: "",
      companyVal_Lab: "",
    };
  }
  onEdit = async (record) => {
    // this.setState({ openGroupAddFom: true });
    // this.setState({ vehicleGroupId: record.deviceGroupId });
    const Id = record.deviceGroupId;

    if (Id) {
      this.context.viewStateStore.setVehicleGroupStates({
        companyId: record.companyId,
      });
      await this.setState({ vehicleGroupId: Id });
      await this.setState({ openGroupAddFom: true });
      // this.props.navigate("/allocatevehicleadd/" + Id);
    }
  };

  async onDelete(record) {
    const response = await this.vehicleGroupStore.deleteRecord({
      deviceGroupId: record.deviceGroupId,
    });

    if (response?.data?.success === "S") {
      message.success(response.data.message);
      this.handleSearch();
    } else {
      message.error(response.data.message);
    }
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevState.listDataUpdate !== this.state.listDataUpdate) {
      const setVehicleGroupStates =
        this.context.viewStateStore.vehicleGroupObject;

      await this.setState({ companyId: setVehicleGroupStates.companyId });
      if (setVehicleGroupStates !== "") {
        await this.vehicleGroupStore.loadData({
          offset: (this.state.currentPage - 1) * this.state.pageSize,
          limit: this.state.pageSize,
          companyId: this.state.companyId,
        });
        const singleData = await this.companyStore.getCompanyDataById(
          setVehicleGroupStates.companyId
        );

        await this.setState({ loadData: 1 });

        await this.setState({
          companyVal_Lab: singleData,
          companyId: setVehicleGroupStates.companyId,
        });
      }
      this.setState({ listDataUpdate: false });
    }
  }
  async componentDidMount() {
    // await this.vehicleGroupStore.loadData({ offset: 0, limit: 50 });
    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });
      await this.setState({ userId: this.props.getUserData().userId });
      await this.handleSearch();
    }
    this.setState({ pageSize: 50 });

    this.columns = [
      {
        // title: "  Device",
        title: this.context.translate("_DEVICE_"),
        dataIndex: "groupname",
        width: "80%",
        render: (value, record) => {
          return (
            <Link
              onClick={(e) => {
                e.preventDefault();
                this.onEdit(record);
              }}
            >
              <FileOutlined /> &nbsp;{value}
            </Link>
          );
        },
      },
      {
        title: this.context.translate("_ACTION_"),
        dataIndex: "Action",
        key: "Action",
        // fixed: 'right',
        width: "20%",
        render: (_, record) => {
          return (
            <>
              <Space>
                {/* <Link
                  onClick={(e) => {
                    e.preventDefault();
                    this.onEdit(record);
                  }}
                >
                  <Tooltip 
                  // title="Edit"  
                  title={this.context.translate("_FLEET_COMPANY_COMPANYLIST_EDIT_")}
                  placement="bottom" color={config.tooltipColorEdit}>
                    <EditFilled />
                  </Tooltip>
                </Link> */}
                <DeleteConfirm
                  onConfirm={(e) => {
                    e.preventDefault();
                    this.onDelete(record);
                  }}
                >
                  <Link>
                    <Tooltip
                      // title="Remove Device"
                      title={this.context.translate(
                        "_FLEET_GROUP_GROUPLIST_DELETE_"
                      )}
                      color={config.tooltipColorDelete}
                      placement="bottom"
                    >
                      <DeleteFilled style={{ color: config.deleteColor }} />
                    </Tooltip>
                  </Link>
                </DeleteConfirm>
              </Space>
            </>
          );
        },
      },
    ];
  }

  async handleTableChange(pagination, filters, sorter) {
    // console.log(pagination);
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    this.handleSearch();
  }

  async handleChange(comp) {
    await this.setState({
      companyId: comp.value,
      pageSize: 50,
      currentPage: 1,
    });
    const singleData = await this.companyStore.getCompanyDataById(comp.value);
    await this.setState({ companyVal_Lab: singleData });
    await this.handleSearch();
  }

  async handleSearch() {
    this.setState({ loading: true });
    await this.vehicleGroupStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      // searchField: this.state.searchField,
      companyId: this.state.companyId,
    });
    await this.setState({ loadData: 1 });
  }
  responseMsg = async (resp) => {
    if (resp.data.success == "S") {
      message.success(resp.data.message);
      this.setState({ openGroupAddFom: false });
      this.setState({ listDataUpdate: true });
      await this.handleSearch();
      // this.props.navigate("/vehiclegrouplist");
    }
    // else if (resp.data.success == "F0") {
    //   resp.data.errors.map((value) => {
    //     message.error(this.context.translate(value["dgerror"]));
    //   });
    // }
    else {
      message.error(this.context.translate(resp.data.message));
    }
  };

  closeModal = () => {
    this.setState({ openGroupAddFom: false, vehicleGroupId: "" });
  };

  render() {
    return (
      <>
        <div style={{ padding: 0 }}>
          <Row className="headerFixed" style={{ height: "50px" }}>
            <Col span={12}>
              <div className="heading">
                {this.context.translate("_FLEET_GROUP_GROUPLIST_TITLE_")}
              </div>
            </Col>
            <Col
              span={12}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <Space
                style={{
                  float:
                    this.context.locale.direction == "ltr" ? "right" : "left",
                }}
              >
                <Tooltip
                  // title="Add"
                  title={this.context.translate("_FLEET_ROLE_ROLELIST_ADDBTN_")}
                  placement="left"
                  color={config.primaryColor}
                >
                  <Button
                    className="addButton"
                    icon={<PlusOutlined />}
                    type="primary"
                    onClick={() =>
                      this.setState({
                        openGroupAddFom: true,
                        vehicleGroupId: "",
                      })
                    }
                  ></Button>
                </Tooltip>
              </Space>
            </Col>
          </Row>
        </div>
        <div
          style={{
            paddingTop: "10px",
            paddingRight: "24px",
            paddingLeft: "24px",
          }}
        >
          <Row className="listInputRow">
            <Col span={16}>
              <Space>
                <CompanyAutocomplete
                  // allowClear={true}
                  value={
                    this.state.companyVal_Lab ? this.state.companyVal_Lab : null
                  }
                  onChange={(value) => this.handleChange(value)}
                  style={{ width: 200 }}
                />
              </Space>
            </Col>
            <Col span={8}>
              <Space
                style={{
                  float:
                    this.context.locale.direction == "ltr" ? "right" : "left",
                }}
              ></Space>
            </Col>
          </Row>

          <ListTable
            currentPage={this.state.currentPage}
            pageSize={this.state.pageSize}
            total={this.vehicleGroupStore?.total}
            columns={this.columns}
            dataSource={this.vehicleGroupStore?.vehicleGroupVehicles}
            loading={this.vehicleGroupStore?.loading}
            onChange={this.handleTableChange}
          />
        </div>

        {this.state.openGroupAddFom && (
          <Modal
            bodyStyle={{ height: "645px" }}
            className="formShowModal" //  {/* css class */}
            // title="Device Details"
            title={this.context.translate("_FLEET_GROUP_GROUPDETAIL_TITLE_")}
            centered
            open={this.state.openGroupAddFom}
            footer={null}
            onCancel={() => {
              this.setState({ openGroupAddFom: false, vehicleGroupId: "" });
            }}
            width={665}
          >
            <div>
              <VehicleGroupAdd
                vehicleGroupId={this.state.vehicleGroupId}
                companyId={this.state.companyId}
                response={this.responseMsg}
                closeModal={this.closeModal}
              />
            </div>
          </Modal>
        )}
      </>
    );
  }
}
VehicleGroupList.contextType = StoreContext;
export default observer(withRouter(VehicleGroupList));
